<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="(route, index) in routes"
          :key="index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

function hasRoleAccess(meta, roleKey) {
  if (!meta || !meta.roles || !meta.roles.length) {
    return true
  }
  return meta.roles.some(role => role === roleKey)
}

function filterRoutesByRole(routes, roleKey) {
  return (routes || []).reduce((result, route) => {
    const current = { ...route }
    if (current.hidden) {
      result.push(current)
      return result
    }

    const selfVisible = hasRoleAccess(current.meta, roleKey)
    if (current.children && current.children.length) {
      current.children = filterRoutesByRole(current.children.map(item => ({ ...item })), roleKey)
      const hasVisibleChildren = current.children.some(child => {
        if (child.hidden) return false
        if (child.meta && child.meta.visible === false) return false
        return true
      })
      if (current.meta) {
        current.meta = { ...current.meta, visible: selfVisible && hasVisibleChildren }
      }
      if (selfVisible && hasVisibleChildren) {
        result.push(current)
      }
      return result
    }

    if (current.meta) {
      current.meta = { ...current.meta, visible: selfVisible && current.meta.visible !== false }
    }
    if (selfVisible) {
      result.push(current)
    }
    return result
  }, [])
}

export default {
  components: { SidebarItem, Logo },

  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      const menuList = this.$router.options.routes
      const roleKey = localStorage.getItem('roles')
      return filterRoutesByRole(menuList.map(item => ({ ...item })), roleKey)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
